export default defineAppConfig({
  ui: {
    strategy: "override",
    primary: "default",
    button: {
      size: {
        xl: 'text-sm leading-6'
      },
      color: {
        white: {
          solid: "ring-1 ring-inset ring-gray-200 text-gray-900 bg-white hover:bg-gray-50 disabled:bg-white focus-visible:ring-2 focus-visible:ring-primary-500",
          ghost: "text-gray-900 hover:bg-white focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500"
        },
        gray: {
          solid: 'text-gray-700 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 focus-visible:ring-2 focus-visible:ring-primary-500',
        },
        "default-secondary": {
          solid: "text-white bg-[#ED2177] hover:bg-[#d72671] disabled:bg-[#ED2177] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#d72671]"
        },
        "persian-green-secondary": {
          solid: "text-white bg-[#fe7768] hover:bg-[#f74f3c] disabled:bg-[#fe7768] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f74f3c]"
        },
        "amaranth-secondary": {
          solid: "text-white bg-[#F7BF65]  hover:bg-[#f4a643] disabled:bg-[#F7BF65] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f4a643]"
        },
        "cosmic-secondary": {
          solid: "text-white bg-[#FDA18A] hover:bg-[#fa8b6f] disabled:bg-[#FDA18A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#fa8b6f]"
        },
        'dark-purple': {
          solid: 'text-white bg-dark-purple bg-[length:200%_auto] bg-gradient-to-r from-dark-purple to-furious-purple hover:bg-center'
        },
        'furious-purple': {
          solid: 'shadow-sm text-white bg-furious-purple hover:bg-[#d72671]',
          soft: 'shadow-sm text-furious-purple hover:bg-furious-purple/10 shadow-none',
        },
        'gentian-navy': {
          soft: 'shadow-sm text-gentian-navy shadow-none',
        },
      },
      default: {
        loadingIcon: 'i-approved-arrow-loader',
      }
    },
    dropdown: {
      ring: "",
      item: {
        active: 'bg-primary-500 text-white'
      }
    },
    formGroup: {
      size: {
        xl: 'text-sm'
      },
      label: {
        base: 'block font-medium text-gray-900 ltr:first-letter:uppercase',
      },
      help: 'mt-2 text-grey-500 text-xs',
      container: 'mt-2 relative',
      error: 'mt-1.5 text-xs text-red-500 rtl:text-right',
    },
    input: {
      rounded: 'rounded-lg',
      placeholder: 'placeholder-gray-400',
      size: {
        xl: 'text-sm leading-6'
      },
      color: {
        white: {
          outline: 'bg-white text-gray-900 ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-primary-500',
        },
      }
    },
    textarea: {
      rounded: 'rounded-lg',
      placeholder: 'placeholder-gray-400',
      size: {
        xl: 'text-sm'
      },
      color: {
        white: {
          outline: 'bg-white text-gray-900 ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-primary-500',
        },
      }
    },
    select: {
      placeholder: 'text-gray-400',
      size: {
        xl: 'text-sm leading-6'
      },
      color: {
        white: {
          outline: "bg-white text-gray-900 ring-1 ring-inset ring-gray-200 focus:ring-2 focus:ring-primary-500"
        }
      },
      default: {
        trailingIcon: "i-approved-angle-down"
      }
    },
    selectMenu: {
      ring: '',
      shadow: 'shadow-[0_0_32px_0_rgba(22,27,124,0.05)]',
      option: {
        base: "cursor-default select-none relative flex items-center justify-between gap-1 mb-0.5",
        selected: "bg-primary text-white",
        selectedIcon: {
          wrapper: 'hidden',
          padding: '',
          base: 'hidden',
        }
      }
    },
    radioGroup: {
      fieldset: 'space-y-1',
    },
    modal: {
      overlay: {
        background: 'bg-gray-950/60',
      },
      rounded: 'rounded-xl',
      shadow: ''
    },
    badge: {
      color: {
        white: {
          solid: "ring-1 ring-inset ring-gray-200 text-gray-900 bg-white hover:bg-gray-50 disabled:bg-white focus-visible:ring-2 focus-visible:ring-primary-500",
          ghost: "text-gray-900 hover:bg-white focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-primary-500"
        },
        gray: {
          solid: 'text-gray-700 bg-gray-50 hover:bg-gray-100 disabled:bg-gray-50 focus-visible:ring-2 focus-visible:ring-primary-500',
        },
        "default-secondary": {
          solid: "text-white bg-[#ED2177] hover:bg-[#d72671] disabled:bg-[#ED2177] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#d72671]"
        },
        "persian-green-secondary": {
          solid: "text-white bg-[#fe7768] hover:bg-[#f74f3c] disabled:bg-[#fe7768] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f74f3c]"
        },
        "amaranth-secondary": {
          solid: "text-white bg-[#F7BF65]  hover:bg-[#f4a643] disabled:bg-[#F7BF65] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f4a643]"
        },
        "cosmic-secondary": {
          solid: "text-white bg-[#FDA18A] hover:bg-[#fa8b6f] disabled:bg-[#FDA18A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#fa8b6f]"
        },
        'dark-purple': {
          solid: 'text-white bg-dark-purple bg-[length:200%_auto] bg-gradient-to-r from-dark-purple to-furious-purple hover:bg-center'
        },
        'furious-purple': {
          solid: 'shadow-sm text-white bg-furious-purple hover:bg-[#d72671]',
          soft: 'shadow-sm text-furious-purple hover:bg-furious-purple/10 shadow-none',
        },
        'gentian-navy': {
          soft: 'shadow-sm text-gentian-navy shadow-none',
        },
      },
    },
    avatar: {
      wrapper: 'relative inline-flex items-center justify-center flex-shrink-0 [&_img]:object-cover',
      size: {
        '3xs': 'h-4 w-4 text-[8px]',
        '2xs': 'h-5 w-5 text-[10px]',
        xs: 'h-6 w-6 text-xs',
        sm: 'h-8 w-8 text-sm',
        md: 'h-11 w-11 text-base',
        lg: 'h-12 w-12 text-lg',
        xl: 'h-14 w-14 text-xl',
        '2xl': 'h-16 w-16 text-2xl',
        '3xl': 'h-20 w-20 text-3xl',
        '5xl': 'h-25 w-25 xs:w-30 xs:h-30 text-3xl'
      },
    },
    notification: {
      default: {
        closeButton: {
          icon: 'i-approved-close',
        }
      }
    },
  }
})
;
